import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  forwardRef,
  Input,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  OnChanges,
  AfterViewChecked,
} from '@angular/core'
import { MatColumnDef, MatHeaderRowDef, MatRowDef, MatTable, MatFooterRowDef } from '@angular/material/table'
import { DataSource } from '@angular/cdk/collections'
import { CdkColumnDef } from '@angular/cdk/table'
import { MatPaginator } from '@angular/material/paginator'

@Component({
  selector: 'lin-table',
  template: `
    <div
      class="table-wrapper"
      [ngClass]="{ 'dynamic-height': pageSize === 100 || pageSize === 25, 'default-height': pageSize === 10 || pageSize === 5 }"
      linPerfectScrollbar
    >
      <div class="table-container">
        <mat-table class="linxio-table" [dataSource]="dataSource || []">
          <ng-content></ng-content>
        </mat-table>
      </div>
    </div>
  `,
  styleUrls: ['./table.component.scss'],
  providers: [
    {
      provide: MatTable,
      useExisting: forwardRef(() => TableComponent),
    },
  ],
  standalone: false,
})
export class TableComponent<T> implements AfterContentInit, AfterViewInit, OnChanges, AfterViewChecked {
  @ContentChildren(MatHeaderRowDef) headerRowDefs: QueryList<MatHeaderRowDef>
  @ContentChildren(MatRowDef) rowDefs: QueryList<MatRowDef<T>>
  @ContentChildren(MatFooterRowDef) footerRowDefs: QueryList<MatFooterRowDef>
  @ContentChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>

  @ViewChild(MatTable, { static: true }) table: MatTable<T>
  @ViewChild(MatPaginator) paginator: MatPaginator

  @Input() dataSource: DataSource<T> | T[] = []
  @Input() pageSize: number = 10

  constructor(
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pageSize']) {
      this.cdr.detectChanges()
    }
  }

  ngAfterContentInit() {
    this.columnDefs.forEach((columnDef) => this.table.addColumnDef(columnDef))
    this.rowDefs.forEach((rowDef) => this.table.addRowDef(rowDef))
    this.headerRowDefs.forEach((headerRowDef) => this.table.addHeaderRowDef(headerRowDef))
    this.footerRowDefs.forEach((footerRowDef) => this.table.addFooterRowDef(footerRowDef))
    this.cdr.detectChanges()
  }

  ngAfterViewChecked() {
    if (this.paginator && !this.pageSize) {
      this.pageSize = this.paginator.pageSize
      this.updateTableWrapperHeight()
      this.cdr.detectChanges()
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.paginator) {
        this.pageSize = this.paginator.pageSize

        this.updateTableWrapperHeight()

        this.paginator.page.subscribe(() => {
          this.pageSize = this.paginator.pageSize
          this.updateTableWrapperHeight()
        })
      }
    })
  }

  updateTableWrapperHeight(): void {
    const tableWrapper = document.querySelector('.table-wrapper') as HTMLElement
    if (!tableWrapper) return

    const pageSize = this.pageSize

    if ([25, 100].includes(pageSize)) {
      this.renderer.removeClass(tableWrapper, 'default-height')
      this.renderer.addClass(tableWrapper, 'dynamic-height')
      tableWrapper.style.height = 'calc(80vh - 60px)'
    } else if ([5, 10].includes(pageSize)) {
      this.renderer.removeClass(tableWrapper, 'dynamic-height')
      this.renderer.addClass(tableWrapper, 'default-height')
      tableWrapper.style.height = '100%'
    }

    this.cdr.detectChanges()
  }

  addColumnDef(columnDef: CdkColumnDef) {
    this.table.addColumnDef(columnDef)
  }

  removeColumnDef(columnDef: CdkColumnDef) {
    this.table.removeColumnDef(columnDef)
  }
}
